import React, { useState, useEffect } from 'react';
import { useAuth } from '../../AuthContext';
import './Dashboard.css';
import UserDashboard from './UserDashboard';
import { useNavigate } from 'react-router-dom';
import { IoIosLogOut } from "react-icons/io";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Dashboard: React.FC = () => {
  const { logout } = useAuth();
  const [overlayOpacity, setOverlayOpacity] = useState(1);
  const navigate = useNavigate();

  const handleLogout = () => {
    const logoutPromise = new Promise<void>((resolve) => {
      setTimeout(() => {
        logout();
        resolve();
      }, 500);
    });

    toast.promise(
      logoutPromise,
      {
        pending: 'Abmeldung läuft...',
        success: 'Sie wurden erfolgreich abgemeldet.',
        error: 'Fehler bei der Abmeldung.'
      }
    ).then(() => {
      navigate('/', { replace: true });
      window.scroll(0, 0);
    });
  };

  useEffect(() => {
    const fadeInterval = setInterval(() => {
      setOverlayOpacity(prev => {
        const newOpacity = prev - 0.10;
        if (newOpacity <= 0) {
          clearInterval(fadeInterval);
          return 0;
        }
        return newOpacity - 0.001;
      });
    }, 5);

    return () => clearInterval(fadeInterval);
  }, []);

  return (
    <>
      <div className="fade-overlay" style={{ opacity: overlayOpacity }} />

      <div className='db-container'>
        <div className='usermenu'>
          <button className='logout' type='button' onClick={handleLogout}><IoIosLogOut /> Logout</button>
        </div>
        <div className="dashboard-container" id="dashboard">

          <h1 className="dashboard-heading">
            Willkommen zu Ihrem Dashboard!
          </h1>
          <UserDashboard />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
